import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@companion-professional/webutils';

const badgeVariants = cva(
  [
    'inline-flex',
    'items-center',
    'rounded-full',
    'border',
    'px-2.5',
    'py-0.5',
    'text-xs',
    'font-semibold',
    'transition-colors',
    'focus:outline-none',
    'focus:ring-2',
    'focus:ring-ring',
    'focus:ring-offset-2'
  ],
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-on-primary',
        secondary: 'border-transparent bg-secondary text-on-secondary',
        destructive: 'border-transparent bg-destructive text-on-destructive',
        outline: 'border-border text-on-widget',
        // The soft variants use the brand tints for status (e.g. checkup state, tags).
        info: 'border-transparent bg-accent text-on-accent',
        success: 'border-transparent bg-brand-mint text-brand-navy',
        warning: 'border-transparent bg-brand-banana text-brand-navy',
        danger: 'border-transparent bg-brand-bubble-gum text-brand-navy',
        muted: 'border-transparent bg-muted text-muted-foreground'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

// Badge is a component that displays a small amount of information.  It's a little like a small button, but doesn't
// necessarily have any click functionality.
function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
